import { Text } from "@govlaunch/web";
import React from "react";
import { ITag } from "~/types/types";
import { ICardViewMode } from "~/src/components/collection/cardViewMode";

interface IBundleCollectionCardTagsProps {
  tags: Pick<ITag, "_id" | "name">[];
  viewMode?: ICardViewMode;
}

export default function BundleCollectionCardTags({
  tags,
  viewMode = ICardViewMode.Bundles,
}: IBundleCollectionCardTagsProps) {
  return (
    <Text
      color="gray.900"
      fontWeight="semibold"
      fontSize={viewMode === ICardViewMode.Bundles ? "lg" : "md"}
      mt={1}
      textAlign="center"
      clamp={2}
    >
      {tags.map((tag) => tag.name).join(", ")}
    </Text>
  );
}
